import React from 'react'
import style from "./PredicatedCareerOption.module.css";
import Bg from "/assets/PdfNew/pgbg9.png";


const PredicatedCareerTable = ({ careerOption, notes = true }) => {
    const careerInfo = careerOption?.career_info || {};

    const formatLabel = (value = "") => {
        if (!value) return "-";

        return value
            .split(",")
            .map(item =>
                item
                    .trim()
                    .replace(/_/g, " ")
            )
            .join(", ");
    };
    const formatLabelToArray = (value = "") => {
        if (!value) return [];

        return value.split(",").map(item => {
            const cleaned = item.trim().replace(/_/g, " ");
            return cleaned === "" ? "-" : cleaned;
        });
    };
    return (
        <div className={style.PredicateCareerBg}>
            <img src={Bg} alt="bg" className={style.PredicateCareerBg} />

            <div className={style.contenttable}>



                {/* Areas to Improve for Greater Success
*/}
  <div className={style.score}>
          <p className={style.sectionTitle} >
            <span>How You Align With The Best In This Field  This is not guesswork.

            </span>
          </p>

          {/* <p className={style.scoreDescription}>
          </p> */}
        </div>
    
          <p className={style.scoreDescription} >
          At SwayamRise, we match every student against the real personality traits, aptitude patterns and strengths of top professionals already excelling in <strong>{formatLabel(careerOption?.career_choice)}</strong>. And out of every career path we assessed, this is where your profile aligned most powerfully.  You are not being pointed in a direction — you are being recognised for who you already are. With the right focus and preparation, <strong>{formatLabel(careerOption?.career_choice)}</strong> is a field where you can genuinely thrive and lead.
          </p>
                <div className={style.score}>
                    <p className={style.sectionTitle} >
                        <span>Areas to Grow for Greater Success

                        </span>
                    </p>

                    <p className={style.scoreDescription}>
                        {`While your strengths are well-aligned with this career, improving the following areas will
enhance your readiness and long-term success:`}
                    </p>
                </div>
                <div className={style.tableWrapper}>
                    <table className={style.careerTable}>
                        <thead>
                            <tr>
                                <th className={style.header} style={{ backgroundColor: "rgba(8, 17, 120, 1)" }}>Area</th>
                                <th className={style.header} style={{ backgroundColor: "rgba(77, 83, 199, 1)" }}>  Areas of Improvement </th>
                                <th className={style.header} style={{ backgroundColor: "rgba(108, 117, 212, 1)" }}>Suggested Actions</th>
                            </tr>
                        </thead>

                        <tbody>
                            {careerInfo?.improvement_aptitude && <tr>
                                <td className={`${style.feature} ${style.aptitude}`}>Aptitude</td>
                                <td>{formatLabel(careerInfo?.improvement_aptitude)}</td>
                                <td>{formatLabel(careerInfo?.suggested_aptitude_improvement)}</td>
                            </tr>}

                            {careerInfo?.personality_improvement && <tr>
                                <td className={`${style.feature} ${style.personality}`}>Personality</td>
                                <td>{formatLabel(careerInfo?.personality_improvement)}</td>
                                <td>{formatLabel(careerInfo?.suggested_personlaity_improvement)}</td>
                            </tr>}

                            {careerInfo?.improvement_subject && <tr>
                                <td className={`${style.feature} ${style.subject}`}>Subject</td>
                                <td>{formatLabel(careerInfo?.improvement_subject)}</td>
                                <td>{formatLabel(careerInfo?.suggested_subject_improvement)}</td>
                            </tr>}

                            <tr>
                                <td className={`${style.feature} ${style.other}`}>
                                    Other Preference
                                </td>

                                <td>
                                    {formatLabelToArray(careerInfo?.improvement_other).length > 0 ? (
                                        <ul style={{ margin: 0, paddingLeft: "18px" }}>
                                            {formatLabelToArray(careerInfo?.improvement_other).map((item, index) => (
                                                <li key={index}>{item}</li>
                                            ))}
                                        </ul>
                                    ) : (
                                        "-"
                                    )}
                                </td>

                                <td>
                                    {formatLabelToArray(careerInfo?.suggested_other_improvement).length > 0 ? (
                                        <ul style={{ margin: 0, paddingLeft: "18px" }}>
                                            {formatLabelToArray(careerInfo?.suggested_other_improvement).map((item, index) => (
                                                <li key={index}>{item}</li>
                                            ))}
                                        </ul>
                                    ) : (
                                        "-"
                                    )}
                                </td>
                            </tr>
                        </tbody>


                    </table>
                </div>
                <br></br>
                <p className={style.scoreDescription} style={{ color: "red" }}>
                    Improving these areas early will significantly increase your chances of excelling in this career
                    and related competitive exams.
                </p>
                {notes && <div className={style.score}>
                    <p className={style.sectionTitle} >
                        <span>                Important Note
                        </span>
                    </p>

                    <p className={style.scoreDescription}>
                        {`These career recommendations are based on current academic data, assessment responses, and self-reported inputs, analyzed using structured assessment frameworks and machine-learning models. The results are intended to provide guidance and direction, not to limit future choices.

Career interests, abilities, and opportunities can evolve over time with exposure, learning, and experience. Students are encouraged to revisit these recommendations periodically and discuss them with parents, mentors, or educators before making important academic or career decisions.`}
                    </p>
                </div>}



            </div>
        </div>)
}

export default PredicatedCareerTable